var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "page-wrap" },
    [
      _c("div", { staticClass: "search" }, [
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("供货单号：")]),
            _c("el-input", {
              attrs: { placeholder: "输入供货单号", clearable: "" },
              model: {
                value: _vm.fromData.supplier_order_no,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "supplier_order_no", $$v)
                },
                expression: "fromData.supplier_order_no",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("货号：")]),
            _c("el-input", {
              attrs: { placeholder: "输入货号", clearable: "" },
              model: {
                value: _vm.fromData.sku_code,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "sku_code", $$v)
                },
                expression: "fromData.sku_code",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("商品名称：")]),
            _c("el-input", {
              attrs: { placeholder: "输入商品名称", clearable: "" },
              model: {
                value: _vm.fromData.product_title,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "product_title", $$v)
                },
                expression: "fromData.product_title",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("城市仓：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "选择城市仓",
                },
                model: {
                  value: _vm.fromData.store_logistics_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "store_logistics_id", $$v)
                  },
                  expression: "fromData.store_logistics_id",
                },
              },
              _vm._l(_vm.cityStoreList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("自提点：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "选择自提点",
                },
                model: {
                  value: _vm.fromData.store_delivery_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "store_delivery_id", $$v)
                  },
                  expression: "fromData.store_delivery_id",
                },
              },
              _vm._l(_vm.selfTakeList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("供货商：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "选择供货商",
                },
                model: {
                  value: _vm.fromData.supplier_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "supplier_id", $$v)
                  },
                  expression: "fromData.supplier_id",
                },
              },
              _vm._l(_vm.supplierList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.title, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("业务员：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "选择业务员",
                },
                model: {
                  value: _vm.fromData.buyer_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "buyer_id", $$v)
                  },
                  expression: "fromData.buyer_id",
                },
              },
              _vm._l(_vm.buyerList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.fullname, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("送货员：")]),
            _c("el-input", {
              attrs: { placeholder: "输入送货员", clearable: "" },
              model: {
                value: _vm.fromData.supplier_deliver_name,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "supplier_deliver_name", $$v)
                },
                expression: "fromData.supplier_deliver_name",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("是否缺货：")]),
            _c(
              "el-select",
              {
                attrs: { clearable: "", placeholder: "选择是否缺货" },
                model: {
                  value: _vm.fromData.is_stockout,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "is_stockout", $$v)
                  },
                  expression: "fromData.is_stockout",
                },
              },
              [
                _c("el-option", { attrs: { label: "全部", value: "" } }),
                _c("el-option", { attrs: { label: "缺货", value: "1" } }),
                _c("el-option", { attrs: { label: "不缺货", value: "0" } }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("供货日：")]),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "选择供货日",
                "value-format": "yyyy-MM-dd",
                clearable: false,
              },
              model: {
                value: _vm.fromData.date,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "date", $$v)
                },
                expression: "fromData.date",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("视频提交时间：")]),
            _c("el-time-picker", {
              attrs: {
                format: "HH:mm",
                "value-format": "HH:mm",
                placeholder: "选择视频提交时间起",
              },
              model: {
                value: _vm.fromData.video_start,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "video_start", $$v)
                },
                expression: "fromData.video_start",
              },
            }),
            _c("el-time-picker", {
              attrs: {
                format: "HH:mm",
                "value-format": "HH:mm",
                placeholder: "选择视频提交时间止",
              },
              model: {
                value: _vm.fromData.video_end,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "video_end", $$v)
                },
                expression: "fromData.video_end",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("label", [_vm._v("提交送货时间：")]),
            _c("el-time-picker", {
              attrs: {
                format: "HH:mm",
                "value-format": "HH:mm",
                placeholder: "选择提交送货开始时间",
              },
              model: {
                value: _vm.fromData.submit_start,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "submit_start", $$v)
                },
                expression: "fromData.submit_start",
              },
            }),
            _c("el-time-picker", {
              attrs: {
                format: "HH:mm",
                "value-format": "HH:mm",
                placeholder: "选择提交送货结束时间",
              },
              model: {
                value: _vm.fromData.submit_end,
                callback: function ($$v) {
                  _vm.$set(_vm.fromData, "submit_end", $$v)
                },
                expression: "fromData.submit_end",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-button", {
              staticClass: "bjsearch",
              attrs: { type: "primary", icon: "el-icon-refresh" },
              on: { click: _vm.onHandleRefresh },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.onHandleSearch },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "warning",
                  icon: "el-icon-upload2",
                  disabled: _vm.disabledExport,
                },
                on: { click: _vm.onHandleExport },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.dataList,
                height: "100%",
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "80",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供货单号",
                  prop: "supplier_order_no",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.supplier_order
                                ? scope.row.supplier_order.supplier_order_no
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "送货员",
                  prop: "deliver_name",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "货号", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.supplier_order_detail
                                ? scope.row.supplier_order_detail.sku_code
                                : scope.row.sku_code
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.supplier_order_detail
                                ? scope.row.supplier_order_detail.sku_name
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "供货商", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.supplier_order &&
                                scope.row.supplier_order.supplier
                                ? scope.row.supplier_order.supplier.title
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "业务员", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.supplier_order &&
                                scope.row.supplier_order.buyer
                                ? scope.row.supplier_order.buyer.fullname
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "城市仓", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.store_logistics
                                ? scope.row.store_logistics.name
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "自提点", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.delivery ? scope.row.delivery.name : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "是否缺货",
                  align: "center",
                  prop: "stockout_text",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "缺货件数",
                  prop: "qc_number",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "是否确认上车",
                  align: "center",
                  prop: "deliver_text",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "上车件数",
                  prop: "deliver_num",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "视频提交时间",
                  prop: "video_last_time",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "提交送货时间",
                  prop: "supplier_deliver_confirm_time",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "上车视频", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewClick(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 查看 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "上车记录", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCheckRecordClick(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 查看 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              align: "right",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.fromData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("CheckRecordDialogForm", { ref: "checkRecordDialogForm" }),
      _c("VideoPlayerDialog", {
        attrs: { visible: _vm.videoDialogVisible, videoList: _vm.videoList },
        on: {
          "update:visible": function ($event) {
            _vm.videoDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }